/* eslint-disable react/jsx-child-element-spacing */
import { Col, Row } from 'antd';
import { Formik } from 'formik';
import styled from 'styled-components';
import { Form, Input } from 'formik-antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { useTimer } from 'react-timer-hook';
import { salesManLogin, generateOtp, additionalResourcesLogin } from 'store/userSlice';
import { Text } from 'atoms';
import { FormActionButtons } from 'forms/FormActionButtons';
import { setinvoiceDate } from 'store/appSlice';

const TIMER = 120;

export function validateRipplrEmail(email) {
	/* eslint-disable no-useless-escape */
	const RIPPLR_MAIL = '@ripplr.in';
	const emailRegExp =
		/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	if (
		emailRegExp.test(email) &&
		email.indexOf(RIPPLR_MAIL, email.length - RIPPLR_MAIL.length) !== -1
	) {
		// Email valid. Procees to test if it's from the right domain (Second argument is to check that the string ENDS with this domain, and that it doesn't just contain it)
		return true;
	}

	return false;
}

export function validateMobileNumber(email) {
	const phoneRegExp = /^[6-9]\d{9}$/gi;

	if (phoneRegExp.test(email)) {
		return true;
	}

	return false;
}

function validateEmailMobile(data) {
	if (validateRipplrEmail(data)) {
		return true;
	}
	if (validateMobileNumber(data)) {
		return true;
	}

	return false;
}

const FormSchema = Yup.object({
	email: Yup.string()
		.required()
		.label('Email/Mobile')
		.test('is-RipplrEmail-Mobile', 'Not a valid Email/Mobile', (value) =>
			validateEmailMobile(value)
		),
	password: Yup.string()
		.label('Password')
		.min(5)
		.when('email', {
			is: (email) => validateRipplrEmail(email),
			then: Yup.string().required(),
			otherwise: Yup.string(),
		}),
	otp: Yup.string()
		.matches(/^[0-9]+$/, 'Must be only digits')
		.min(4, 'Must be exactly 4 digits')
		.max(4, 'Must be exactly 4 digits'),
});

let initialValues = {
	email: undefined,
	password: undefined,
	otp: '',
};

if (process.env.NODE_ENV === 'development') {
	/**
	 * On development set login form details prefilled with data
	 */
	initialValues = {
		email: undefined,
		password: undefined,
		otp: '',
	};
}

export const FormPassWord = styled(Form.Item)`
	input.ant-input {
		height: 30px;
	}
`;

function LoginForm() {
	const dispatch = useDispatch();
	const history = useHistory();
	const [isMobile, setIsMobile] = useState(false);
	const time = new Date();

	time.setSeconds(time.getSeconds() + TIMER);
	const { seconds, minutes, isRunning, restart } = useTimer({
		time,
		onExpire: () => console.warn('onExpire called'),
	});

	function triggerTimer() {
		const triggerTime = new Date();

		triggerTime.setSeconds(triggerTime.getSeconds() + TIMER);
		restart(triggerTime);
	}

	function handleSubmit(values, { setErrors, resetForm, setSubmitting }) {
		if (validateMobileNumber(values.email) && values.otp === '') {
			setIsMobile(true);
			triggerTimer();
			dispatch(generateOtp({ mobile: values.email }, setErrors))
				.then(() => {
					setSubmitting(false);
				})
				.catch((e) => {
					setSubmitting(false);
					console.log('OTP catch', e);
				})
				.finally(() => {
					// setSubmitting(false);
				});
		} else if (validateMobileNumber(values.email) && values.otp !== '') {
			setIsMobile(true);
			dispatch(salesManLogin({ mobile: values.email, ...values }, setErrors))
				.then(() => {
					dispatch(setinvoiceDate());
					setSubmitting(false);
					resetForm();
					history.push('/collection');
				})
				.catch((e) => {
					setSubmitting(false);
					console.log('Sales Man catch', e);
				})
				.finally(() => {
					// setSubmitting(false);
				});
		} else if (validateRipplrEmail(values.email) && values.password !== '') {
			setIsMobile(false);
			dispatch(additionalResourcesLogin(values, setErrors))
				.then(() => {
					dispatch(setinvoiceDate());
					setSubmitting(false);
					resetForm();
					// history.push('/sales-men');
				})
				.catch((e) => {
					setSubmitting(false);
					console.log('Login form catch', e);
				})
				.finally(() => {
					// setSubmitting(false);
				});
		}
	}

	function resendOTP(mobile) {
		triggerTimer();
		dispatch(generateOtp({ mobile }));
	}

	return (
		<Formik
			enableReinitialize
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
		>
			{({ values, isSubmitting, resetForm }) => (
				<Form layout="vertical" hideRequiredMark>
					<div
						style={{
							maxHeight: '350px',
							width: '100%',
							marginTop: '2rem',
							overflowY: 'auto',
							overflowX: 'hidden',
						}}
					>
						<Row gutter={8} justify="space-between">
							<Col span={24}>
								<Form.Item
									name="email"
									hasFeedback={false}
									showValidateSuccess={false}
									label="Salesman Phone Number / Billing Executive Id"
									className="custom-label"
									labelCol={{ span: 24 }}
									wrapperCol={{ span: 24 }}
								>
									<Input name="email" />
								</Form.Item>
							</Col>
						</Row>
						<Row
							hidden={!validateRipplrEmail(values.email)}
							gutter={8}
							justify="space-between"
						>
							<Col span={24}>
								<FormPassWord
									name="password"
									hasFeedback={false}
									showValidateSuccess={false}
									label="Password"
									className="custom-label"
									labelCol={{ span: 24 }}
									wrapperCol={{ span: 24 }}
								>
									<Input.Password name="password" />
								</FormPassWord>
							</Col>
						</Row>
						{isMobile && !validateRipplrEmail(values.email) && (
							<>
								<Row gutter={8} justify="space-between">
									<Col span={24}>
										<Form.Item
											name="otp"
											hasFeedback={false}
											showValidateSuccess={false}
											label="OTP"
											className="custom-label"
											labelCol={{ span: 24 }}
											wrapperCol={{ span: 24 }}
										>
											<Input type="number" name="otp" />
										</Form.Item>
									</Col>
								</Row>
								<Row
									gutter={8}
									justify="space-between"
									align="middle"
									className="mb-20"
								>
									<Col span={8}></Col>
									<Col span={8} className="center">
										{isRunning && (
											<Text fontWeight="600" fontSize="16px">
												<span>{minutes}</span>:
												<span>{seconds < 10 ? '0' : ''}</span>
												<span>{seconds}</span>
											</Text>
										)}
									</Col>
									<Col span={8} className="right">
										{!isRunning && (
											<Text
												fontWeight="600"
												fontSize="10px"
												color="#113F5F"
												cursor="pointer"
												onClick={() => resendOTP(values.email)}
											>
												Resend OTP
											</Text>
										)}
									</Col>
								</Row>
							</>
						)}
					</div>
					<FormActionButtons
						resetForm={resetForm}
						isSubmitting={isSubmitting}
						showDebug={false}
						saveText={
							isMobile || validateRipplrEmail(values.email) ? 'Login' : 'Submit'
						}
						cancelText="Reset"
						showCancel={false}
						isValid={
							!(isMobile && !validateRipplrEmail(values.email) && values.otp === '')
						}
					/>
				</Form>
			)}
		</Formik>
	);
}

export default LoginForm;
